import RefundsTable from './RefundsTable';

export default RefundsTable;
